var map = {
	"./amplify-amazon-button_5.entry.js": [
		843,
		5
	],
	"./amplify-auth-fields_9.entry.js": [
		844,
		16
	],
	"./amplify-authenticator.entry.js": [
		845,
		0,
		24
	],
	"./amplify-button_3.entry.js": [
		846,
		6
	],
	"./amplify-chatbot.entry.js": [
		870,
		14
	],
	"./amplify-checkbox.entry.js": [
		847,
		25
	],
	"./amplify-confirm-sign-in_7.entry.js": [
		848,
		0,
		26
	],
	"./amplify-container.entry.js": [
		849,
		27
	],
	"./amplify-federated-buttons_2.entry.js": [
		850,
		7
	],
	"./amplify-federated-sign-in.entry.js": [
		851,
		20
	],
	"./amplify-form-field_4.entry.js": [
		852,
		28
	],
	"./amplify-greetings.entry.js": [
		853,
		8
	],
	"./amplify-icon-button.entry.js": [
		854,
		29
	],
	"./amplify-icon.entry.js": [
		855,
		21
	],
	"./amplify-link.entry.js": [
		856,
		30
	],
	"./amplify-nav_2.entry.js": [
		857,
		9
	],
	"./amplify-photo-picker.entry.js": [
		858,
		18
	],
	"./amplify-picker.entry.js": [
		859,
		19
	],
	"./amplify-radio-button_2.entry.js": [
		860,
		0,
		31
	],
	"./amplify-s3-album.entry.js": [
		861,
		10
	],
	"./amplify-s3-image-picker.entry.js": [
		862,
		11
	],
	"./amplify-s3-image.entry.js": [
		863,
		17
	],
	"./amplify-s3-text-picker.entry.js": [
		864,
		12
	],
	"./amplify-s3-text.entry.js": [
		865,
		13
	],
	"./amplify-select-mfa-type.entry.js": [
		866,
		15
	],
	"./amplify-sign-in-button.entry.js": [
		867,
		22
	],
	"./amplify-toast.entry.js": [
		868,
		32
	],
	"./amplify-tooltip.entry.js": [
		869,
		33
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 822;
module.exports = webpackAsyncContext;